import { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
export var useWindowSize = function useWindowSize() {
  var _useState = useState({
    width: null,
    height: null
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  function handleResize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }

  useEffect(function () {
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};
export var Breakpoint;

(function (Breakpoint) {
  Breakpoint["Small"] = "sm";
  Breakpoint["Medium"] = "md";
  Breakpoint["Large"] = "lg";
  Breakpoint["XLarge"] = "xl";
})(Breakpoint || (Breakpoint = {}));

export var useBreakpoint = function useBreakpoint() {
  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var _useState2 = useState(null),
      breakpoint = _useState2[0],
      setBreakpoint = _useState2[1];

  function handleBreakpoint(width) {
    if (width < 768) {
      return Breakpoint.Small;
    } else if (width < 1024) {
      return Breakpoint.Medium;
    } else if (width < 1200) {
      return Breakpoint.Large;
    } else {
      return Breakpoint.XLarge;
    }
  }

  useEffect(function () {
    if (width) {
      var bp = handleBreakpoint(width);
      setBreakpoint(bp);
    }
  }, [width]);
  return breakpoint;
};
export var useJoveBreakpoint = function useJoveBreakpoint() {
  var _useState3 = useState(false),
      isMobileLayout = _useState3[0],
      setIsMobileLayout = _useState3[1];

  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down('md'));
  useEffect(function () {
    setIsMobileLayout(isMobile);
  }, [isMobile]);
  return {
    isMobileLayout: isMobileLayout
  };
};